/**
 * Dotažení vendor knihovny až ve chvíli, kdy je opravdu potřeba.
 *
 * Swiper a cookie lišta musí být v hlavním bundlu — banner i lišta jsou vidět
 * hned. Choices a GLightbox ale obsluhují věci pod ohybem nebo skryté za
 * kliknutím, a přitom dohromady zabíraly ~36 kB gzip. Na pomalém mobilu to je
 * pásmo, které chybělo obrázku banneru, takže LCP čekalo na knihovny, které
 * návštěvník za celou návštěvu ani nepotřeboval.
 *
 * Každý soubor se stahuje nejvýš jednou — opakovaná volání dostanou tentýž slib.
 */
const rozpracovane = new Map();

export function loadVendor(src) {
    if (rozpracovane.has(src)) return rozpracovane.get(src);

    const slib = new Promise((resolve) => {
        const el = document.createElement('script');
        el.src = src;
        el.async = true;
        el.onload = () => resolve(true);
        // Když se knihovna nestáhne, stránka musí zůstat funkční: select zůstane
        // nativní, galerie se otevře jako obyčejný odkaz na fotku.
        el.onerror = () => resolve(false);
        document.head.appendChild(el);
    });

    rozpracovane.set(src, slib);
    return slib;
}

/**
 * Dotažení CSS knihovny (lazy-cookies / lazy-gallery / lazy-choices). Cesty
 * s otiskem verze předává šablona v atributu data-lazy-css na <html>.
 * Slib se splní po načtení stylů (nebo i po chybě – knihovna pak poběží
 * s vlastním vzhledem, ale nesmí se kvůli CSS zaseknout).
 */
const styly = new Map();

export function loadStyle(name) {
    if (styly.has(name)) return styly.get(name);

    let href = '';
    try { href = JSON.parse(document.documentElement.dataset.lazyCss || '{}')[name] || ''; } catch { /* bez cesty */ }
    const slib = new Promise((resolve) => {
        if (!href) { resolve(false); return; }
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => resolve(true);
        link.onerror = () => resolve(false);
        document.head.appendChild(link);
    });

    styly.set(name, slib);
    return slib;
}
